<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-navigation-drawer :mini-variant.sync="mini" app v-model="drawer" >
      <v-list-item style="background-color: white; height: 65px">
        <div v-if="mini">
          <img alt="Vue Material Admin" src="../assets/gfi.png" style="max-height: 30px">
        </div>
        <div v-if="!mini">
          <img alt="Vue Material Admin" src="../assets/gfi.png" style="max-height: 50px">
        </div>
      </v-list-item>
      <v-list nav dense>
        <v-list-item-group v-model="item" color="primary">
          <router-link :to="items[i].path" v-for="(item, i) in items" :key="i">
            <v-list-item>
              <v-list-item-icon>
                <v-icon small v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { EventBus } from '../main'
export default {
  name: 'SideBar',
  data () {
    return {
      drawer: true,
      mini: true,
      fav: true,
      menu: false,
      item: '',
      message: false,
      hints: true,
      items: [
        { text: 'Dashboard', icon: 'mdi-chart-areaspline', path: "/dashboard" },
        { text: 'Results', icon: 'mdi-file-document', path: "/result" },
        { text: 'Export Data', icon: 'mdi-file-excel', path: "/bulkDownload" },
        { text: 'Learning Resouces', icon: 'mdi-cogs', path: "/learningResources" }
      ]
    }
  },
  methods: {
    handleSideBar: function () {
      this.mini = !this.mini
    },
    handleSideBarMobile: function () {
      this.drawer = !this.drawer
    },
  },
  created () {
    EventBus.$on('Clicked', this.handleSideBar),
    EventBus.$on('Sidebar', this.handleSideBarMobile)
  }
}
</script>
